(function () {

  const modal = document.getElementById('konst-free-promo-modal');
  const titleEl = document.getElementById('konst-promo-title');
  const bodyEl = document.getElementById('konst-promo-body');
  const primaryBtn = document.getElementById('konst-promo-primary');
  const secondaryBtn = document.getElementById('konst-promo-secondary');
  
  // 1. Get Settings
  const settings = window.KONST_FREE_PROMO;
  if (!settings || !settings.enabled) return;

  // --- UI HELPERS ---
  function openModal() {
    if (!modal) return;
    modal.style.display = 'block';
    requestAnimationFrame(() => modal.classList.add('is-open'));
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    setTimeout(() => modal.style.display = 'none', 750);
  }

  function setText(t, b) {
    if (titleEl) titleEl.innerText = t;
    if (bodyEl) bodyEl.innerText = b.replace('{{cookie}}', settings.cookieName);
  }

  // --- LOGIC HELPER: Box Size ---
  function getCurrentBoxSize() {
    // A. Try variable first
    if (window.YVR_CURRENT_BOX_SIZE) return window.YVR_CURRENT_BOX_SIZE;

    // B. Scrape DOM
    try {
      const selected = document.querySelector(
        '.BentoSMB-Box-Selector__Item.selected, .BentoSMB-Box-Selector__Item.active, .BentoSMB-Box-Selector__Item[aria-selected="true"]'
      );
      if (selected) {
        const match = (selected.innerText || selected.textContent).match(/\d+/);
        if (match) {
          window.YVR_CURRENT_BOX_SIZE = Number(match[0]);
          return window.YVR_CURRENT_BOX_SIZE;
        }
      }
    } catch (e) { console.error(e); }
    return null;
  }

  // --- MAIN INTERCEPTOR ---
  window.konstInterceptAddToCart = function (realItems) {
    
    // 1. Determine Size (Variable -> DOM -> Cart Count)
    let size = getCurrentBoxSize();
    if (!size && realItems && Array.isArray(realItems)) {
      const totalCount = realItems.reduce((sum, item) => sum + (item.quantity || 1), 0);
      if (totalCount >= 4 && totalCount <= 5) size = 4;
      else if (totalCount >= 6 && totalCount <= 8) size = 6;
      else if (totalCount >= 9 && totalCount <= 11) size = 9;
      else if (totalCount >= 12) size = 12;
      
      if (size) console.log('[FREE PROMO] Recovered size from items:', size);
    }
    console.log('[FREE PROMO SIZE]', size);


    // 2. HELPER: Combine Box + Free Cookies into ONE request
    // This fixes the "12 pack only adding 1" bug by sending a single clean list to Shopify.
    function checkoutWithFreeCookies(qty) {
      // Clone the original items so we don't mess up the original array
      const finalItems = realItems.map(item => ({...item}));
      
      // Add the free cookie as a new line item
      finalItems.push({
        id: Number(settings.variant),
        quantity: qty
      });

      console.log('[FREE PROMO] Adding combined items:', finalItems);
      shopifyAddToCart(finalItems);
    }


    // --- SIZE 4 (Upgrade Prompt) ---
    if (size === 4) {
      setText(settings.t4, settings.b4);
      primaryBtn.innerText = settings.upgradeText;
      
      // CUSTOM TEXT: "Proceed with 4 cookies" instead of generic "No thanks"
      secondaryBtn.innerText = "Proceed with 4 cookies"; 

      primaryBtn.onclick = () => {
        closeModal();
        if (typeof upgradeToNextBox === 'function') upgradeToNextBox();
      };

      secondaryBtn.onclick = () => {
        closeModal();
        shopifyAddToCart(realItems);
      };
      openModal();
      return;
    }

    // --- SIZE 6 or 9 (1 Free Cookie) ---
    if (size === 6 || size === 9) {
      setText(settings.t69, settings.b69);
      primaryBtn.innerText = settings.claimText;
      secondaryBtn.innerText = settings.noText;

      primaryBtn.onclick = () => {
        closeModal();
        checkoutWithFreeCookies(1); // Add 1 free cookie
      };

      secondaryBtn.onclick = () => {
        closeModal();
        shopifyAddToCart(realItems);
      };
      openModal();
      return;
    }

    // --- SIZE 12+ (2 Free Cookies) ---
    if (size === 12) {
      setText(settings.t12, settings.b12);
      
      // CUSTOM TEXT: Plural for 12 pack
      primaryBtn.innerText = "Claim Cookies!"; 
      secondaryBtn.innerText = settings.noText;

      primaryBtn.onclick = () => {
        closeModal();
        checkoutWithFreeCookies(2); // Add 2 free cookies
      };

      secondaryBtn.onclick = () => {
        closeModal();
        shopifyAddToCart(realItems);
      };
      openModal();
      return;
    }

    // Fallback (No promo active/matched)
    shopifyAddToCart(realItems);
  };

  // --- Close Button Listeners ---
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (
        e.target.classList.contains('yvr-box-full-close') ||
        e.target.classList.contains('yvr-box-full-dismiss')
      ) {
        closeModal();
      }
    });
  }

})();